import React, { lazy, Suspense, useEffect, useState } from "react";
import Calendar from "../../components/Calendar/Calendar";
// import ContenExBox from "../../components/ContentEx/ContenExBox";
import "./Kalendar.scss";
import { useGlobalLocation } from "../../shared/LocationContext";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot";
import { useIdContext } from "../../shared/IdProvider";
import CalendarMonthsLinks from "../../components/CalendarMonthsLinks/CalendarMonthsLinks";
import { calendarYears } from "../../components/Calendar/calendar-data/calendar-data.js";
import Zadusnice from "../../components/Zadusnice/Zadusnice";
import MultiplexAd from "../../components/AdvModule/MultiplexAd";
// import Widget from "../../UI/Widget/Widget";

const Widget = lazy(() => import("../../UI/Widget/Widget.js"));
export default function Kalendar() {
  const location = useGlobalLocation();
  const { slug, currentYear, yearIndex } = useIdContext();
  return (
    <div className="kalendar">
      <div className="banner-wrapper bilbord">
        <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723658374440-0"} />
      </div>
      <div className="kalendar-wrapper">
        <div className="kalendar-left">
          <Calendar />
          <div className="kalendar-left-wrapper">
            <h2>{`Crkveni kalendar ${slug || currentYear}. godine po mesecima:`}</h2>
            <CalendarMonthsLinks />
          </div>
        </div>
        <div className="kalendar-right">
          <Zadusnice setYear={2026} boxTitle={`🕯 Zadušnice u ${2026}. godini`} data={calendarYears[0].item_list[yearIndex]} />

          {/* <div className="posni_kalendar">
            <h2>Kalendar posta</h2>
            <div
              style={{
                width: "100%",
                height: "300px",
                border: "1px solid red",
              }}
            >
              Kalendar posta
            </div>
          </div> */}
          <div className="banner-wrapper xl_sticky">
            <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1723682121612-0"} />
          </div>
        </div>
      </div>
      <div className="banner-wrapper">
        <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1724367417806-0"} />
      </div>
      {/* <ContenExBox /> */}
      <Suspense fallback={<div></div>}>
        <Widget />
      </Suspense>
      <MultiplexAd />
      {/* <div className="banner-wrapper">
        <AdManagerSlot
          adUnitPath={location.pathname}
          slotNumber={"div-gpt-ad-1735207510691-0"}
        />
      </div> */}
    </div>
  );
}
